import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useStyles } from '../Calendar.styles';
import { CalendarEventTypeId } from '../../../pages/Calendar/Calendar.types';
import { getAddProcedureButtonColor } from '../helpers';
import TooltipOne from '../../TooltipOne/TooltipOne.component';

interface AddProcedureButtonProps {
  eventType: CalendarEventTypeId;
  onClick: () => void;
}

export const AddProcedureButton: React.FC<AddProcedureButtonProps> = ({ eventType, onClick }) => {
  const classes = useStyles();

  return (
    <div className={classes.addProcedureIcon} style={{ color: getAddProcedureButtonColor(eventType) }}>
      <TooltipOne title="Dodaj procedurę" placement="top">
        <AddCircleIcon color="inherit" onClick={onClick} />
      </TooltipOne>
    </div>
  );
};
